
<style>
.shoot_box {
  padding-bottom: 10px;
  margin: 1.2rem 1.2rem;
  border-bottom: 1px solid rgb(204, 204, 204);
}
.shoot_title {
  font-size: 1.4rem;
}
.shoot_msg {
  margin-top: 10px;
  color: #666;
}
.shoot_content {
  min-height: 20rem;
  margin: 1.2rem 1.2rem;
}
.userful_box {
  text-align: center;
  padding: 20px;
}
.userful_box img {
  width: 3rem;
}
.userful_box div {
  color: #666;
}
</style>
<template>
  <div>
    <div class="m_tb_box">
      <mt-header :title="title">
        <a @click="$router.go(-1)" slot="left">
          <mt-button icon="back">返回</mt-button>
        </a>
      </mt-header>

      <div v-if="titleArr.length>1">
        <table width="100%" class="m_tb_1" border="0" cellspacing="0" cellpadding="0">
          <tr class="m_tr_1">
            <td
              class="m_td_1 "
              :class="currentIndex==index?'active': ''"
              @click="jump('jump'+index,index)"
              v-for="(item,index) in titleArr"
              :key="index"
            >
              <div class="m_aText textLine">{{item}}</div>
              <div :class="currentIndex==index?'m_arrow': 'm_arrow_2'"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="shoot_box">
      <div class="shoot_title">{{title}}</div>
      <div class="m_clearLR shoot_msg">
        <div class="m_floatL">发布日期：{{date|partFilter}}</div>
        <div class="m_floatR">{{view?view:'0'}}人阅读</div>
      </div>
    </div>
    <div class="shoot_content"></div>
    <div class="userful_box">
      <img src="./../assets/images/userful.png" @click="userful">
      <div>{{num?num:'0'}}人觉得有用</div>
    </div>
  </div>
</template>

<script>
import { getArticleById, putThumbup } from '@/api/api'
import { MessageBox } from 'mint-ui'
export default {
  data () {
    return {
      num: 0,
      id: -1,
      title: '无命题',
      view: 0,
      listLength: -1,
      titleArr: [],
      currentIndex: 0,
      baifen: '',
      date: '',
      baifen2: '',
      isFirst: false,
      timer: false
    }
  },
  filters: {
    partFilter (value) {
      if (!value) return ''
      var time = value.split('T')[0]
      var year = time.split('-')
      value = year[0] + '年' + year[1] + '月' + year[2] + '日'
      return value
    }
  },
  created () {
    var sUserAgent = navigator.userAgent.toLowerCase()
    var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
    var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
    var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
    var bIsAndroid = sUserAgent.match(/android/i) == 'android'
    var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
    var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {

    } else {
      location.href = 'https://m.buypos.cn/pc/home.html#/troubleshootingInfo?id=' + this.$route.query.id
    }
    getArticleById(this.$route.query.id).then(res => {
      var down_info = document.querySelector('.shoot_content')
      down_info.innerHTML = res.data.body
      this.num = res.data.useful
      this.id = res.data.id
      this.title = res.data.title
      this.view = res.data.views
      this.date = res.data.created_at

      setTimeout(() => {
        document.querySelector('.shoot_box').style.marginTop =
            document.querySelector('.m_tb_box').clientHeight + 20 + 'px'
      }, 0)
    })
  },
  methods: {
    userful () {
      putThumbup(this.id).then(res => {
        if (res.data.status == 'true') {
          this.num++
          MessageBox('提示', '点赞成功')
        } else MessageBox('提示', '亲,不能重复点赞！')
      })
    },
    jump (id, index) {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/troubleshootingInfo.vue